import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactDom from 'react-dom';

import Home from './Home';
import Sculpture from './Sculpture';
import News from './News';
import Contact from './Contact';
// import registerServiceWorker from './registerServiceWorker';

// basename={'dev'}
const Root = () => (
    <Router>
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/Sculpture" component={Sculpture} />
            <Route exact path="/News" component={News} />
            <Route exact path="/Contact" component={Contact} />
        </Switch>
    </Router>
)

ReactDom.render(
    <Root />,
    document.getElementById('root')
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js